/*
Docs:
https://cdn.jsdelivr.net/npm/@checkr/web-sdk/dist/web-sdk.umd.js
https://docs.checkr.com/embeds/
*/

// @ts-nocheck
/**
 * Name: @checkr/web-sdk
 * Version: 0.0.58
 */
var focusableSelectors = [
  'a[href]:not([tabindex^="-"])',
  'area[href]:not([tabindex^="-"])',
  'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
  'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
  'select:not([disabled]):not([tabindex^="-"])',
  'textarea:not([disabled]):not([tabindex^="-"])',
  'button:not([disabled]):not([tabindex^="-"])',
  'iframe:not([tabindex^="-"])',
  'audio[controls]:not([tabindex^="-"])',
  'video[controls]:not([tabindex^="-"])',
  '[contenteditable]:not([tabindex^="-"])',
  '[tabindex]:not([tabindex^="-"])',
]
var TAB_KEY = 9
var ESCAPE_KEY = 27
function A11yDialog(element) {
  this._show = this.show.bind(this)
  this._hide = this.hide.bind(this)
  this._maintainFocus = this._maintainFocus.bind(this)
  this._bindKeypress = this._bindKeypress.bind(this)
  this.$el = element
  this.shown = false
  this._id = this.$el.getAttribute('data-a11y-dialog') || this.$el.id
  this._previouslyFocused = null
  this._listeners = {}
  this.create()
}
A11yDialog.prototype.create = function () {
  this.$el.setAttribute('aria-hidden', true)
  this.$el.setAttribute('aria-modal', true)
  this.$el.setAttribute('tabindex', -1)
  if (!this.$el.hasAttribute('role')) {
    this.$el.setAttribute('role', 'dialog')
  }
  this._openers = $$('[data-a11y-dialog-show="' + this._id + '"]')
  this._openers.forEach(
    function (opener) {
      opener.addEventListener('click', this._show)
    }.bind(this)
  )
  this._closers = $$('[data-a11y-dialog-hide]', this.$el).concat(
    $$('[data-a11y-dialog-hide="' + this._id + '"]')
  )
  this._closers.forEach(
    function (closer) {
      closer.addEventListener('click', this._hide)
    }.bind(this)
  )
  this._fire('create')
  return this
}
A11yDialog.prototype.show = function (event) {
  if (this.shown) {
    return this
  }
  this._previouslyFocused = document.activeElement
  this.$el.removeAttribute('aria-hidden')
  this.shown = true
  moveFocusToDialog(this.$el)
  document.body.addEventListener('focus', this._maintainFocus, true)
  document.addEventListener('keydown', this._bindKeypress)
  this._fire('show', event)
  return this
}
A11yDialog.prototype.hide = function (event) {
  if (!this.shown) {
    return this
  }
  this.shown = false
  this.$el.setAttribute('aria-hidden', 'true')
  if (this._previouslyFocused && this._previouslyFocused.focus) {
    this._previouslyFocused.focus()
  }
  document.body.removeEventListener('focus', this._maintainFocus, true)
  document.removeEventListener('keydown', this._bindKeypress)
  this._fire('hide', event)
  return this
}
A11yDialog.prototype.destroy = function () {
  this.hide()
  this._openers.forEach(
    function (opener) {
      opener.removeEventListener('click', this._show)
    }.bind(this)
  )
  this._closers.forEach(
    function (closer) {
      closer.removeEventListener('click', this._hide)
    }.bind(this)
  )
  this._fire('destroy')
  this._listeners = {}
  return this
}
A11yDialog.prototype.on = function (type, handler) {
  if (typeof this._listeners[type] === 'undefined') {
    this._listeners[type] = []
  }
  this._listeners[type].push(handler)
  return this
}
A11yDialog.prototype.off = function (type, handler) {
  var index2 = (this._listeners[type] || []).indexOf(handler)
  if (index2 > -1) {
    this._listeners[type].splice(index2, 1)
  }
  return this
}
A11yDialog.prototype._fire = function (type, event) {
  var listeners = this._listeners[type] || []
  var domEvent = new CustomEvent(type, { detail: event })
  this.$el.dispatchEvent(domEvent)
  listeners.forEach(
    function (listener) {
      listener(this.$el, event)
    }.bind(this)
  )
}
A11yDialog.prototype._bindKeypress = function (event) {
  if (!this.$el.contains(document.activeElement)) return
  if (this.shown && event.which === ESCAPE_KEY && this.$el.getAttribute('role') !== 'alertdialog') {
    event.preventDefault()
    this.hide(event)
  }
  if (this.shown && event.which === TAB_KEY) {
    trapTabKey(this.$el, event)
  }
}
A11yDialog.prototype._maintainFocus = function (event) {
  if (
    this.shown &&
    !event.target.closest('[aria-modal="true"]') &&
    !event.target.closest('[data-a11y-dialog-ignore-focus-trap]')
  ) {
    moveFocusToDialog(this.$el)
  }
}
function toArray(collection) {
  return Array.prototype.slice.call(collection)
}
function $$(selector, context) {
  return toArray((context || document).querySelectorAll(selector))
}
function moveFocusToDialog(node) {
  var focused = node.querySelector('[autofocus]') || node
  focused.focus()
}
function getFocusableChildren(node) {
  return $$(focusableSelectors.join(','), node).filter(function (child) {
    return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length)
  })
}
function trapTabKey(node, event) {
  var focusableChildren = getFocusableChildren(node)
  var focusedItemIndex = focusableChildren.indexOf(document.activeElement)
  if (event.shiftKey && focusedItemIndex === 0) {
    focusableChildren[focusableChildren.length - 1].focus()
    event.preventDefault()
  } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
    focusableChildren[0].focus()
    event.preventDefault()
  }
}
function instantiateDialogs() {
  $$('[data-a11y-dialog]').forEach(function (node) {
    new A11yDialog(node)
  })
}
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', instantiateDialogs)
  } else {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(instantiateDialogs)
    } else {
      window.setTimeout(instantiateDialogs, 16)
    }
  }
}
var modalStyles =
  '.checkr-dialog-container{position:fixed;inset:0;z-index:100;display:flex;align-items:center;justify-content:center;overflow:auto}.checkr-dialog-container[aria-hidden=true]{display:none}.checkr-dialog-overlay{position:fixed;inset:0;background-color:#2b2e387f;animation:checkr-fade-in .1s both}.checkr-dialog-content{position:relative;z-index:100;width:80%;max-width:800px;max-height:80vh;padding:2rem;margin:auto;overflow-y:auto;background-color:#fff;border-radius:.1rem;animation:checkr-fade-in .1s .2s both,checkr-slide-up .4s .2s both}@keyframes checkr-fade-in{0%{opacity:0}}@keyframes checkr-slide-up{0%{transform:translateY(10%)}}.checkr-dialog-close{position:absolute;top:.5em;right:.5em;width:1.2em;height:1.2em;padding:0;font-size:1.25em;font-weight:700;text-align:center;cursor:pointer;background-color:transparent;border:0;transition:.15s}@media screen and (width <= 480px){.checkr-dialog-content{width:100%}}\n'
const triggerModal = (onShow, params, nonce) => {
  const modalContainer = document.createElement('div')
  modalContainer.id = 'checkr-modal-container'
  modalContainer.innerHTML = html
  document.body.appendChild(modalContainer)
  const styleElement = document.createElement('style')
  if (nonce) styleElement.setAttribute('nonce', nonce)
  styleElement.innerHTML = `.checkr-dialog-content {width: ${params.width};}` + modalStyles
  document.getElementsByTagName('head')[0].appendChild(styleElement)
  const container = document.querySelector('#checkr-dialog')
  const dialog = new A11yDialog(container)
  dialog.on('hide', () => {
    modalContainer.remove()
    styleElement.remove()
    dialog.destroy()
  })
  dialog.on('show', () => {
    onShow('.checkr-dialog-content')
  })
  dialog.show()
}
const html = `
  <div
    class="checkr-dialog-container"
    id="checkr-dialog"
    data-testid="checkr-dialog"
    aria-hidden="true"
    aria-labelledby="checkr-dialog-title"
    aria-describedby="checkr-dialog-description"
  >
    <div class="checkr-dialog-overlay" data-a11y-dialog-hide></div>
    <div class="checkr-dialog-content" role="document">
      <button
        data-a11y-dialog-hide
        class="checkr-dialog-close"
        aria-label="Close this dialog window"
      >
        &times;
      </button>
    </div>
  </div>
`
const PROD_URL = 'https://web-sdk-services.checkr.com'
const STAGING_URL = 'https://web-sdk-services.checkr-staging.com'
const SANDBOX_URL = 'https://web-sdk-services.checkr-sandbox.com'
const MR_URL = 'https://mr-x-web-sdk-services.checkr-sandbox.com'
const LOCAL_URL = 'https://web-sdk-services.checkr.localhost'
const DEFAULT_URL = PROD_URL
const getUrl = (env) => {
  if (!env) {
    return DEFAULT_URL
  }
  if (env.toLowerCase().startsWith('prod')) return PROD_URL
  if (env.toLowerCase().startsWith('staging')) return STAGING_URL
  if (env.toLowerCase().startsWith('sandbox')) return SANDBOX_URL
  if (env.toLowerCase().startsWith('mr')) return MR_URL.replace('mr-x', env.toLowerCase())
  if (env.toLowerCase().startsWith('local')) return LOCAL_URL
  return DEFAULT_URL
}
function loadEmbedDefinitions(env) {
  const webSDKServicesURL = window.devWebSDKServicesURL ? window.devWebSDKServicesURL : getUrl(env)
  const maxAttempts = 20
  const waitTime = 300
  const checkGlobal = (successCallback, failureCallback, attempt = 0) => {
    if (window.CheckrEmbedDefinitions) successCallback()
    if (attempt >= maxAttempts) failureCallback()
    else {
      setTimeout(() => {
        checkGlobal(successCallback, failureCallback, attempt + 1)
      }, waitTime)
    }
  }
  return new Promise((resolve, reject) => {
    const parent = document.head || document.body || document.documentElement
    const scriptAlreadyExists = parent.querySelector(`script[src*="${webSDKServicesURL}"]`)
    const successCallback = () => {
      resolve(window.CheckrEmbedDefinitions)
    }
    const failureCallback = () => {
      reject(new Error(`Failed to load script: ${webSDKServicesURL}`))
    }
    if (scriptAlreadyExists) {
      checkGlobal(successCallback, failureCallback)
      return
    }
    const script = document.createElement('script')
    const loadend = () => {
      script.onerror = null
      script.onload = null
    }
    script.onerror = () => {
      loadend()
      failureCallback()
    }
    script.onload = () => {
      loadend()
      successCallback()
    }
    script.async = true
    script.src = `${webSDKServicesURL}/lib/checkr-embed-definitions.js`
    parent.appendChild(script)
  })
}
async function refetchSessionToken(
  sessionTokenPath,
  sessionTokenRequestHeaders = () => {
    return {}
  }
) {
  const getRequestHeaders = () => {
    const presetHeaders = { 'Content-type': 'application/json' }
    const headers = sessionTokenRequestHeaders()
    return { ...presetHeaders, ...headers }
  }
  const response = await fetch(sessionTokenPath, {
    method: 'POST',
    headers: getRequestHeaders(),
  })
  if (!response.ok) {
    throw new Error(
      JSON.stringify({
        status: response.status,
        message: await response.json(),
      })
    )
  }
  try {
    const jsonBody = await response.json()
    return jsonBody.token
  } catch {
    return null
  }
}
async function sendOauthToken(oauthTokenPath, oauthToken) {
  const response = await fetch(oauthTokenPath, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify({ code: oauthToken }),
  })
  if (!response.ok) {
    throw new Error(
      JSON.stringify({
        status: response.status,
        message: await response.json(),
      })
    )
  }
  return true
}
const version = '0.0.58'
function withInternalProps(props) {
  var _a
  const internalProps = {
    closeModal: () => {
      const modalContainer = document.getElementById('checkr-modal-container')
      const modalStyles2 = document.getElementById('checkr-modal-styles')
      const dialog = new A11yDialog(document.querySelector('#checkr-dialog'))
      modalContainer.remove()
      modalStyles2.remove()
      dialog.destroy()
    },
    isOpenedAsModal: () => !!document.getElementById('checkr-modal-container'),
    callbackOauthToken: (oauthToken) => sendOauthToken(props.oauthTokenPath, oauthToken),
    onSessionTokenNeed: () => refetchSessionToken(props.sessionTokenPath, props.sessionTokenRequestHeaders),
    webSdkVersion: version,
    parentHost: (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname,
  }
  return {
    ...props,
    ...internalProps,
  }
}
class Embed {
  constructor(props) {
    this.props = withInternalProps(props)
  }
  render(containerSelector) {
    loadEmbedDefinitions(this.props.env).then((embedDefinitions) => {
      const embedName = Object.getPrototypeOf(this).constructor.embedName()
      const component = embedDefinitions[embedName](this.props)
      component.render(containerSelector)
    })
  }
  modal(params = { width: '600px' }) {
    triggerModal(
      (modalContentSelector) => {
        this.render(modalContentSelector)
      },
      params,
      this.props.cspNonce
    )
  }
  static useReact(React, ReactDOM) {
    return (props) => {
      const embedName = this.embedName()
      const [embedDefinitions, setEmbedDefinitions] = React.useState(null)
      const [embedProps, setEmbedProps] = React.useState(null)
      React.useEffect(() => {
        setEmbedProps(withInternalProps(props))
      }, [props])
      React.useEffect(() => {
        if (embedProps) {
          loadEmbedDefinitions(embedProps == null ? void 0 : embedProps.env).then((embedDefinitions2) => {
            setEmbedDefinitions(embedDefinitions2)
          })
        }
      }, [embedProps])
      if (embedProps && embedDefinitions) {
        const embedDefinition = embedDefinitions[embedName]
        const Component = embedDefinition.driver('react', { React, ReactDOM })
        return React.createElement(Component, embedProps, null)
      } else {
        return React.createElement('div', null)
      }
    }
  }
}
class NewInvitation extends Embed {
  constructor(props = {}) {
    super(props)
  }
  static embedName() {
    return 'NewInvitation'
  }
}
class ReportsOverview extends Embed {
  constructor(props = {}) {
    super(props)
  }
  static embedName() {
    return 'ReportsOverview'
  }
}
class DisclosureConsent extends Embed {
  constructor(props = {}) {
    super(props)
  }
  static embedName() {
    return 'DisclosureConsent'
  }
}
class SignUpFlow extends Embed {
  constructor(props = {}) {
    super(props)
  }
  static embedName() {
    return 'SignUpFlow'
  }
}
var index = {
  NewInvitation,
  ReportsOverview,
  DisclosureConsent,
  SignUpFlow,
}
export { index as Embeds }
